import { PackageName } from "app/common/constants/packageNames";

export const SEASONAL_PROMO_CODES_MAP: Partial<Record<PackageName, string>> = {
    // CI/ Starter monthly -> CI annually
    [PackageName.StarterMonthly]: "FLASH30",
    [PackageName.CompetitiveIntelligenceMonthly]: "FLASH30",

    // CI/ Starter annually -> CI+SEO+AEO annually
    [PackageName.StarterAnnual]: "FLASH30",
    [PackageName.CompetitiveIntelligenceAnnual]: "FLASH30",

    // CI+SEO+AEO/ Professional monthly -> CI+SEO+AEO annually
    [PackageName.ProfessionalMonthly]: "FLASH30",
    [PackageName.CompetitiveIntelligenceSeoAeoMonthly]: "FLASH30",

    //CI+SEO+AEO/ Proffesional annually -> CI+SEO+AEO+Ads annually
    [PackageName.ProfessionalAnnual]: "ADS30",
    [PackageName.CompetitiveIntelligenceSeoAeoAnnual]: "ADS30",

    //CI+SEO+AEO+Ads monthly -> CI+SEO+AEO+Ads annually
    [PackageName.CompetitiveIntelligenceSeoAeoAdsMonthly]: "FLASH30",
} as const;

export const SEASONAL_DISCOUNT_UPGRADE_MAP = {
    FLASH30: {
        // CI/ Starter monthly -> CI/ Starter annually
        [PackageName.CompetitiveIntelligenceMonthly]: PackageName.CompetitiveIntelligenceAnnual,
        [PackageName.StarterMonthly]: PackageName.CompetitiveIntelligenceAnnual,

        // CI/ Starter annually -> CI+SEO+AEO annually
        [PackageName.StarterAnnual]: PackageName.CompetitiveIntelligenceSeoAeoAnnual,
        [PackageName.CompetitiveIntelligenceAnnual]: PackageName.CompetitiveIntelligenceSeoAeoAnnual,

        // CI+SEO+AEO/ Professional monthly -> CI+SEO+AEO annually
        [PackageName.ProfessionalMonthly]: PackageName.CompetitiveIntelligenceSeoAeoAnnual,
        [PackageName.CompetitiveIntelligenceSeoAeoMonthly]: PackageName.CompetitiveIntelligenceSeoAeoAnnual,

        //CI+SEO+AEO+Ads monthly -> CI+SEO+AEO+Ads annually
        [PackageName.CompetitiveIntelligenceSeoAeoAdsMonthly]: PackageName.CompetitiveIntelligenceSeoAeoAdsAnnual,
    },
    ADS30: {
        //CI+SEO+AEO/ Proffesional annually -> CI+SEO+AEO+Ads annually
        [PackageName.ProfessionalAnnual]: PackageName.CompetitiveIntelligenceSeoAeoAdsAnnual,
        [PackageName.CompetitiveIntelligenceSeoAeoAnnual]: PackageName.CompetitiveIntelligenceSeoAeoAdsAnnual,
    },
} as const satisfies Record<string, Partial<Record<PackageName, PackageName>>>;

export const SEASONAL_CAMPAIGN_DISCOUNT_PERCENTAGE = 30;
